import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';
import { AppComponent } from '../app.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@angular/cdk/platform';
import { BottomSheet } from "../bottom.sheet";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { LocationService } from "../location.service";

@Component({
    selector: 'app-vendor-profile',
    templateUrl: './vendor-filter.component.html',
    styleUrls: ['./vendor-filter.component.scss'],
})
export class VendorFilterComponent {
    getId;
    proof: boolean;
    account: boolean;
    log: boolean = false;
    conf: boolean = true;
    url;
    Proof;
    AdsProof;
    id;
    orgs: any = [];
    categories: any = [];
    verified: boolean = false;
    name;
    housenbr;
    loader: boolean = true;
    street;
    city;
    region;
    state;
    getData;
    mob;
    zipcode;
    Proid;
    confirm: boolean;
    pend: boolean = false;
    userCredits: any;
    userCreditsView: boolean = false;
    id1;
    credits;
    users: any;
    contractors: any;
    code; //role code
    orgName: any;
    active: boolean = false;
    tagRole: boolean;
    category: any;
    catId;

    constructor(public service: ApiService,
        public router: Router,
        public handler: HandlerService,
        public bottomSheet: MatBottomSheet,
        public auth: AuthService,
        public app: AppComponent,
        public sanitizer: DomSanitizer,
        public platform: Platform,
        public location: LocationService) {
    }

    ionViewWillEnter() {
        sessionStorage.setItem('vendorApp', 'true');
        this.id = localStorage.getItem('organizationId');
        this.loader = true;
        let y = JSON.parse(localStorage.getItem('capabilityOrg')).find(res => res.id == this.id);
        this.orgName = y.name;
        sessionStorage.setItem("orgCd", y.code);
        sessionStorage.setItem("orgId", this.id)
        sessionStorage.setItem("roleId", 'SC');
        if (y.id == this.id) {
            this.tagRole = true;
        }
        this.loader = true;
        this.getOrgs()
        this.categories = this.getCategories(y.id)
        this.service.getUsersByOrg('SC', this.id, null).subscribe((res: any) => {
            if (res) {
                this.users = res;
                // this.users= this.users.filter(res =>{return res.verified == true})
                this.contractors = res;

                if (res.userCredits) {
                    this.userCredits = res.userCredits[0].creditPoints;
                    this.userCreditsView = true;
                } else {
                    this.userCreditsView = false;
                }
                // this.dupUsers=this.dupUsers.filter(res =>{return res.verified == true});

                this.loader = false;

            } else {
                this.handler.res("No Data Found");
                this.loader = false;
                this.users = [];
                this.contractors = [];
            }
        });

    }

    getOrgs() {
        this.service.getOrg().subscribe((res: any) => {
            this.orgs = res;
        })
    }

    getCategories(id) {
        this.service.getCategoriesByOrg(id).subscribe((res: any) => {
            this.categories = res;
            console.log(res)
        })
    }

    get(id) {
        sessionStorage.setItem('roleId', 'SC')
        this.router.navigate(['vendorProfile1/', +id])
    }

    roles(id) {
        this.router.navigate(['/tag-role', id]);
    }

    openBottomSheet(): void {
        const dialogRef = this.bottomSheet.open(BottomSheet, {
            data: this.orgs,
        });
        dialogRef.afterDismissed().subscribe((res: any) => {
            this.orgName = res.name;
            this.id = res.id;
            this.categories = res.categories;
            sessionStorage.setItem("categories", res.categories);
            sessionStorage.setItem("orgCd", res.code);
            sessionStorage.setItem("orgId", this.id);
            this.searchFilter();
        });
    }


    openBottomSheetCategory(): void {
        const dialogRef = this.bottomSheet.open(BottomSheet, {
            data: this.categories,
        });
        dialogRef.afterDismissed().subscribe((res: any) => {
            this.category = res.name;
            this.catId = res.id;
            sessionStorage.setItem("category", this.catId);
            this.searchFilter();
        });
    }

    onInput() {
        this.location.contractorFilterautoComplete();

    }

    searchFilter() {
        const userData = {};
        Object.assign(userData, { orgId: sessionStorage.getItem('orgId') })
        const location = JSON.parse(localStorage.getItem('location'))
        const category = JSON.parse(sessionStorage.getItem('category'))
        if (category) {
            Object.assign(userData, { categoryId: category })
        }
        if (location) {
            Object.assign(userData, { lat: location[0].lat, lon: location[0].lon })
        }
        this.loader = true;
        this.service.filterContractor(userData).subscribe((response: any) => {


            if (response) {

                this.users = response;
                // this.users= this.users.filter(res =>{return res.verified == true})
                this.contractors = response;

                if (response.userCredits) {
                    this.userCredits = response.userCredits[0].creditPoints;
                    this.userCreditsView = true;
                } else {
                    this.userCreditsView = false;
                }
                // this.dupUsers=this.dupUsers.filter(res =>{return res.verified == true});
                this.loader = false;
            } else {
                this.handler.res("No Data Found");
                this.loader = false;
                this.users = [];
                this.contractors = [];
            }
        });
    }

    refreshData(event) {
        this.loader = true;
        this.ionViewWillEnter();
        setTimeout(() => {
            event.target.complete();
        }, 1000);
    }

    clearSearch() {
        this.location.newSearch = ''
        this.category = ''
        this.ionViewWillEnter();
    }


}
